import FusionCharts from"@fusioncharts/constructor/src/constructor";import"@fusioncharts/constructor/src/decryption";import defaultFeatures from"../features";FusionCharts.addDep(defaultFeatures);export default FusionCharts;


//////////////////
// WEBPACK FOOTER
// ./~/fusioncharts/core/index.js
// module id = Mt+p
// module chunks = 5